import { useMutation } from "@tanstack/react-query";
import apiV2 from "api-v2";
import { useInvalidateMfaStatus } from "./useMfaStatus";

export interface MfaDisablePayload {
	password: string;
}

const disableMfa = async (payload: MfaDisablePayload): Promise<void> => {
	await apiV2.delete("/mfa/totp", { data: payload });
};

export const useMfaDisable = () => {
	const invalidateMfaStatus = useInvalidateMfaStatus();

	return useMutation<void, Error, MfaDisablePayload>({
		mutationFn: disableMfa,
		onSuccess: () => {
			invalidateMfaStatus();
		},
	});
};
